import { render } from "./GorgiasLogoIcon.vue?vue&type=template&id=6f3352d8"
import script from "./GorgiasLogoIcon.vue?vue&type=script&lang=js"
export * from "./GorgiasLogoIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/flydata-next/flydata-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__